import { ActionTree } from 'vuex';

// Store's root state
import { RootState } from '@/store/store.types';

// Section actions
import { Actions as CompanyActions } from '@/store/sections/company/company.actions';
import { Actions as ProductsActions } from '@/store/sections/products/products.actions';
import { Actions as RequestActions } from '@/store/sections/request/request.actions';
import { Actions as SpacesActions } from '@/store/sections/spaces/spaces.actions';
import { Actions as SystemsActions } from '@/store/sections/systems/systems.actions';

/**
 *  Holding every action of the store.
 */
export const actions: ActionTree<RootState, RootState> = {

    /**
     *  Every section's actions.
     */
    ...CompanyActions,
    ...ProductsActions,
    ...RequestActions,
    ...SpacesActions,
    ...SystemsActions,

};
